


const CreatorTestimonials = () => {
  const testimonials = [
  {
    name: 'Sarah Johnson',
    role: 'Tech Reviewer',
    subscribers: '250K',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_103b528db-1763293982935.png",
    alt: 'Professional headshot of woman with long brown hair in white blouse smiling at camera',
    quote: 'Switching to this service was the best decision for my channel. My editor understands my style perfectly, and the turnaround time lets me post consistently.',
    rating: 5
  },
  {
    name: 'Marcus Chen',
    role: 'Lifestyle Vlogger',
    subscribers: '180K',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b96df5c7-1763298849215.png",
    alt: 'Professional headshot of Asian man with short black hair in navy blazer smiling confidently',
    quote: 'The pricing calculator helped me budget perfectly. I went from spending 20 hours editing to focusing entirely on content creation. Game changer!',
    rating: 5
  },
  {
    name: 'Emily Rodriguez',
    role: 'Educational Content',
    subscribers: '420K',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9f45209-1763294258604.png",
    alt: 'Professional headshot of Hispanic woman with wavy brown hair in teal top smiling warmly',
    quote: 'The motion graphics and animations they add make my educational videos stand out. My engagement rates have doubled since partnering with them.',
    rating: 5
  }];


  return null;
};

export default CreatorTestimonials;